module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header dfcenter cr666 font15"
  }, [_c('div', {
    staticClass: "logo font18"
  }, [_vm._v("Rain.js")]), _vm._v(" "), _c('div', {
    staticClass: "space"
  }), _vm._v(" "), _c('search'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nav dfcenter"
  }, [_c('span', {
    staticClass: "link"
  }, [_vm._v("教程")]), _vm._v(" "), _c('span', {
    staticClass: "link"
  }, [_vm._v("API")]), _vm._v(" "), _c('span', {
    staticClass: "link"
  }, [_vm._v("示例")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1b2dd557!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 419
// module chunks = 2